<template>
  <div class="home-layout">
    <img
      v-if="
        ['hlldriver', 'hlluser'].includes(portType) && showData.shareComponent
      "
      class="share"
      @click="shareWxMini"
      src="https://static.huolala.cn/image/b27c9b4f21691c6d963b415d6b4603afc9ea0b2c.png"
    />
    <img
      v-if="showData.header"
      class="default-img"
      :src="showData.header"
      alt=""
    />
    <section
      class="inner-box"
      :style="{ marginTop: showData.bodyMarginTop + 'rem' }"
    >
      <!-- 广告图1 -->
      <article class="mb-20">
        <img class="default-img" :src="showData.advertising1" />
      </article>
      <!-- 跑马灯 start -->
      <div class="rollComponent mb-20" v-if="showData.rollComponent">
        <div class="price-list">
          <!-- <div class="price-title">正在加载预约用户列表......</div> -->
          <div class="price-list-item list-item-1">
            <div class="price-list-item-l">
              131****2872 已预约购车礼包
            </div>
            <div class="price-list-item-l">183****9946 已预约购车礼包</div>
            <div class="price-list-item-l">157****1677 已预约购车礼包</div>
            <div class="price-list-item-l">171****2174 已预约购车礼包</div>
            <div class="price-list-item-l">135****2621 已预约购车礼包</div>
          </div>
          <div class="price-list-item list-item-2">
            <div class="price-list-item-l">177****2729 已预约购车礼包</div>
            <div class="price-list-item-l">187****6672 已预约购车礼包</div>
            <div class="price-list-item-l">159****3098 已预约购车礼包</div>
            <div class="price-list-item-l">136****6699 已预约购车礼包</div>
            <div class="price-list-item-l">139****7360 已预约购车礼包</div>
          </div>
        </div>
      </div>
      <!-- 跑马灯 end -->
      <!-- 留资模块 start -->
      <inputModel
        class="mb-23"
        v-show="showData.input.buttonImg"
        :appLocation="appLocation"
        :isAppEnv="isAppEnv"
        :configData="showData.input"
        :successSubmit="showData.successSubmit"
        :submitTimeValue="submitTimeValue"
        @goOtherActivity="goOtherActivity"
        @save="save"
        :optionsData="optionsData"
        :templateId="templateId"
        @openCity="cityPickerPopupVisible = true"
      />
      <!-- 留资模块 end -->
      <!-- 广告图3 start -->
      <article v-if="showData.advertising3.length">
        <img
          v-for="item in showData.advertising3"
          v-if="item.img"
          :key="item.id"
          class="default-img mb-23"
          :src="item.img"
        />
      </article>
      <!-- 广告图3 start -->
      <!-- 2辆车模块 -->
      <!-- <carModel
        v-if="
          showData.recommendTwoCarModel && showData.recommendTwoCarModel.carList
        "
        v-show="showData.recommendTwoCarModel.carList.length"
        :carData="showData.recommendTwoCarModel"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'rent'"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      /> -->
      <!-- 推荐车型模块 start 即将remove -->
      <!-- 推荐车型1 -->
      <!-- <recommendCarModel
        v-if="showData.recommendCar.carImg"
        :configData="showData.recommendCar"
        :submitTimeValue="submitTimeValue"
        @changeVehicle="changeVehicle"
      /> -->
      <!-- 推荐车型1 -->
      <!-- <recommendCarModel
        v-if="showData.recommendCar.carImg"
        :configData="showData.recommendCar2"
        :submitTimeValue="submitTimeValue"
        @changeVehicle="changeVehicle"
      /> -->
      <!-- 推荐车型模块 end 即将remove -->
      <!-- 买车模块 start -->
      <!-- <carModel
        v-show="showData.buyCar.carList.length"
        :carData="showData.buyCar"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'buy'"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      /> -->
      <!-- 买车模块 end -->
      <!-- 租车模块 留下复用  start -->
      <!-- <carModel
        v-show="showData.rentCar.carList.length"
        :carData="showData.rentCar"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'rent'"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      /> -->
      <!-- <carModel
        v-show="showData.rentCar.carList.length"
        :carData="showData.rentCar"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'rent'"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      /> -->
      <VehicleIntroduce
        v-for="(item, index) in vehicleIntroduceOptions"
        :key="index"
        :carData="showData.rentCar"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'rent'"
        :vehItem="item"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      />
      <!-- 租车模块  end -->
      <article>
        <img
          v-for="item in showData.advertising4"
          :key="item.id"
          class="default-img mb-15"
          :src="item.img"
        />
      </article>
      <!-- 二手车 买车 start -->
      <!-- <carModel
        v-show="showData.usedCar.carList.length"
        :carData="showData.usedCar"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'buy'"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      /> -->
      <!-- 二手车 买车 end -->
      <!-- 2辆车模块 start -->
      <!-- <carModel
        v-if="showData.twoCarModel && showData.twoCarModel.carList"
        v-show="showData.twoCarModel.carList.length"
        :carData="showData.twoCarModel"
        :portType="portType"
        :submitTimeValue="submitTimeValue"
        :typeName="'rent'"
        @goOtherActivity="goOtherActivity"
        @changeVehicle="changeVehicle"
      ></carModel> -->
      <!-- 2辆车模块 end -->
      <article>
        <img
          v-for="item in showData.advertising2"
          :key="item.id"
          class="default-img mb-15"
          :src="item.img"
        />
      </article>
      <inputModel
        class="mb-23"
        v-show="showData.input.buttonImg"
        :appLocation="appLocation"
        :isAppEnv="isAppEnv"
        :configData="showData.input"
        :successSubmit="showData.successSubmit"
        :submitTimeValue="submitTimeValue"
        @goOtherActivity="goOtherActivity"
        @save="save"
        :optionsData="optionsData"
        :templateId="templateId"
        @openCity="cityPickerPopupVisible = true"
      />
      <VideoRecommend
        v-for="(item, index) in videoRecommendOptions"
        :key="item.topImg + index"
        :videoRecommendOptions="item"
        @changeVehicle="changeVehicle"
      />
      <!-- 输入框 start -->
      <popupBottom
        ref="popupBottomBox"
        :configData="showData.input"
        :intentionVehicle="intentionVehicle"
        @save="save"
        :optionsData="optionsData"
        @openCity="cityPickerPopupVisible = true"
      ></popupBottom>
      <saveImgPopup ref="saveImgPopupBox"></saveImgPopup>
      <!-- <div id="parent">
        <div id="children"></div>
      </div> -->
      <div class="drag-box">
        <!-- 悬浮框 1 -->
        <VueDragResize
          v-if="showData.suspensionComponent1.buttonImg"
          class="drag-box-child-1"
          :w="100"
          :h="100"
          :x="posX1"
          :y="posY1"
          v-on:dragging="handleDragging1"
          :parentLimitation="true"
          :isResizable="false"
          @clicked="handleClicked1"
          v-on:dragstop="handleDragStop1"
        >
          <img
            style="width: 100px; height: auto"
            :src="showData.suspensionComponent1.buttonImg"
          />
        </VueDragResize>
        <!-- 悬浮框 2 -->
        <VueDragResize
          v-if="showData.suspensionComponent2"
          class="drag-box-child-2"
          :w="100"
          :h="100"
          :x="posX2"
          :y="posY2"
          v-on:dragging="handleDragging2"
          :parentLimitation="true"
          :isResizable="false"
          @clicked="handleClicked2"
          axis="y"
        >
          <div
            class="left-box"
            @touchend="touchend"
            :style="{
              backgroundColor: showData.suspensionComponent2.buttonColor,
              color: showData.suspensionComponent2.fontColor
            }"
          >
            <div data-xuanfu="p">
              {{ showData.suspensionComponent2.buttonText }}
            </div>
            <div class="item2">
              <img :src="xuanfuIcon" alt="" />
            </div>
          </div>
          <div v-if="xuan2Show" class="right-box">
            <div class="item-box">
              <div
                class="item-box-item"
                v-for="(item, index) in showData.suspensionComponent2.enterList"
                :key="index"
                @touchend="touchendItem(item)"
              >
                <img v-if="item.img" :src="item.img" alt="" />
              </div>
            </div>
          </div>
        </VueDragResize>
      </div>
      <!-- suspensionComponent1 -->
      <!-- <transition name="slide-fade">
        <div v-if="showData.suspensionComponent1" id="lottery-icon-box">
          @click="
              goOtherActivity({
                typeName: 'miniprogram',
                recordName: '浮动图标打开小程序',
                openPopupType: 'signIn',
                page: 'page/tabBar/homepage/index'
              })
            "
          <img
            @click="handleSuspensionComponent1Click"
            style="left: 0"
            :src="showData.suspensionComponent1.buttonImg"
            alt=""
          />
        </div>
      </transition> -->
      <!-- suspensionComponent2 -->
      <!-- <transition name="slide-fade">
        <div id="lottery-icon-box-2" @click="handleXuanfu2">
          <div>悬浮框2</div>
          <div class="item2">
            <img :src="xuanfuIcon" alt="" />
          </div>
        </div>
      </transition> -->
      <!-- <transition v-if="xuan2Show">
        <div id="lottery-icon-box-3">
          <div class="item-box">
            <div
              class="item-box-item"
              v-for="(item, index) in showData.suspensionComponent2.enterList"
              :key="index"
              @click="handleItemClick(item)"
            >
              <img :src="item.img" alt="" />
            </div>
          </div>
        </div>
      </transition> -->
      <!-- 底部公众号 -->
      <div class="single-img-box">
        <img
          class="default-img"
          v-if="showData.bottomQrCode"
          :src="showData.bottomQrCode.img"
          alt=""
        />
      </div>
      <!-- <gzh
        :templateName="templateName"
        :currentRef="currentRef"
        :portType="portType"
      ></gzh> -->
      <div class="bottom-profile">
        <p>如有疑问请拨打客服热线咨询：4006373636</p>
        <p>深圳市啦啦配送有限公司</p>
        <p>粤ICP备2021013159号</p>
      </div>
    </section>
    <!-- <change-to v-if="isShowShortRent" @recordClick="recordClick"></change-to> -->
    <van-popup v-model="popupVisible" round>
      <div class="close-hint-popup">
        <h5>你确定要退出拉拉购车么？</h5>
        <div class="confirm" @click="comfirmClose">确定</div>
        <div class="cancel" @click="popupVisible = false">取消</div>
      </div>
    </van-popup>
    <van-popup v-model="cityPickerPopupVisible" round position="bottom">
      <van-area
        title="选择所在地"
        :area-list="areaList"
        @cancel="cityPickerPopupVisible = false"
        @confirm="handleConfirmCityPick"
      />
    </van-popup>
  </div>
</template>

<script>
import VueDragResize from "vue-drag-resize";
import { getUrlParam, calcSubmit, getNetworkType } from "@/utils/util";
import { getAppLocation } from "@/utils/app-location";
import recordDriver from "@/utils/recordDriver";
import getAppUserData from "@/utils/appUserData";
import appDriverData from "@/utils/appDriverData";
import defaultCode from "@/utils/defaultCode";
import { webcall } from "@/utils/webcall";
import carModel from "./subpage/car-model";
import VehicleIntroduce from "./subpage/vehicle-introduce.vue";
import VideoRecommend from "./subpage/video-recommend.vue";
import inputModel from "./subpage/input-model";
import popupBottom from "./subpage/popup-bottom";
import gzh from "./subpage/gzh";
import saveImgPopup from "./subpage/save-img-popup";
import changeTo from "./subpage/change-to";
import { pointMap } from "@/utils/point-map.js";
import {
  openWXMiniprogram,
  AppCloseWebView,
  toShareMiprogramNew
} from "@/utils/hllApp";
import { recordClick } from "@/utils/recordMTA";
import { init_wx } from "@/utils/WeChat";
import recommendCarModel from "./subpage/recommend-car-model";
// 高德定位
// import { gdLocation } from "@/utils/gdLocation";
// 腾讯定位
// import { getCityData } from "@/utils/getLocation";
// 百度定位
import { getLocation } from "@/utils/baidu-location";
import { pageRecord } from "@/utils/record";
import { Area, Dialog } from "vant";
import { areaList } from "@vant/area-data";
import api from "@/api";
import { lalaMallApi, lalaMallNotAdminApi } from "@/utils/config";
const axios = require("axios");
import ua from "@hll/user-agent";

export default {
  name: "Home",
  components: {
    carModel,
    VehicleIntroduce,
    VideoRecommend,
    inputModel,
    popupBottom,
    saveImgPopup,
    changeTo,
    gzh,
    recommendCarModel,
    vanArea: Area,
    VueDragResize
  },
  data() {
    return {
      vehicleIntroduceOptions: [],
      videoRecommendOptions: [],
      dragCount1: 0,
      dragCount2: 0,
      posX1: 0,
      posY1: 0,
      posX2: 0,
      posY2: 0,
      areaList,
      cityPickerPopupVisible: false,
      popupVisible: false,
      templateName: "",
      isShow: false,
      showData: {
        id: "",
        header: "",
        bodyMarginTop: "-3.2",
        advertising1: "", // 广告图1
        // 输入框
        input: {
          img: "", // 头部
          btnBackImg: "", // 按钮背景图片
          btnText: "", // 按钮文字
          buttonImg: "",
          buttonText: "",
          fields: []
        },
        // 底部输入框
        inputFooter: {
          img: "", // 头部
          btnBackImg: "", // 按钮背景图片
          btnText: "" // 按钮文字
        },
        recommendCar: {
          img: "", // 头部
          btnBackImg: "", // 按钮背景图片
          btnText: "", // 按钮文字
          carImg: "", // 车型图片
          carName: "", // 车型名
          carIntroduce: "", // 车型优惠
          introduce: "" // 整个模块介绍
        },

        recommendCar2: {
          img: "", // 头部
          btnBackImg: "", // 按钮背景图片
          btnText: "", // 按钮文字
          carImg: "", // 车型图片
          carName: "", // 车型名
          carIntroduce: "", // 车型优惠
          introduce: "" // 整个模块介绍
        },

        buyCar: {
          headerImg: "", // 头部图片
          contentImg: "", // 内容图
          advantageImg: "", // 优势图
          btnBackImg: "",
          btnText: "",
          carList: []
        },
        usedCar: {
          // 二手车
          headerImg: "", // 头部图片
          contentImg: "", // 内容图
          advantageImg: "", // 优势图
          btnBackImg: "",
          btnText: "",
          carList: []
        },
        rentCar: {
          headerImg: "", // 头部图片
          contentImg: "", // 内容图
          advantageImg: "", // 优势图
          btnBackImg: "",
          btnText: "",
          carList: []
        },
        twoCarModel: {
          headerImg: "", // 头部图片
          contentImg: "", // 内容图
          advantageImg: "", // 优势图
          btnBackImg: "",
          btnText: "",
          carList: []
        },
        advertising2: [],
        advertising3: [],
        advertising4: [],
        // successSubmit: {
        //   img: "", // 提示小图
        //   carIntroduce: "", // 提示文案1
        //   btnText: "", // 按钮文案
        //   btnBackImg: "", // 打开的url
        //   orderNum: 1
        // },
        successSubmit: null,
        suspensionComponent1: {
          buttomImg: ""
        },
        suspensionComponent2: null,
        bottomQrCode: null,
        shareComponent: null,
        rollComponent: null
      },
      msg: "货拉拉",
      styleData: "-3.2rem",
      optionsData: {
        address: "",
        carType: "buy", // rent:租车 buy:买车
        phone: "",
        nickName: "",
        city: "",
        driverId: "",
        remarkCity: "",
        lat: "",
        lng: ""
      },
      appLocation: {
        city: "",
        lat: "",
        lng: "",
        remarkCity: ""
      },
      // 高德地图
      gdCityData: {
        city: "",
        lat: "",
        lng: "",
        district: ""
      },
      currentRef: getUrlParam("ref"),
      currentClueFrom: "",
      templateId: getUrlParam("templateId"), // 这个参数主要是用户后台配置暂时用
      submitTimeValue: "", // 租车成功提交了 buy: 提交了买车, rent: 提交了租车
      portType: getUrlParam("portType"), // hlldriver
      intentionVehicle: {}, // 意向车型
      urlCityId: "", // url带过来的城市id
      mode: getUrlParam("mode"),
      isAppEnv: false,
      want: getUrlParam("want"),
      xuan2Show: false,
      xuanfuIcon:
        "https://static.huolala.cn/image/8799b69cd23f702252f3502b7afbe1a35f192874.png",
      suspensionComponent1Image: ""
    };
  },
  // watch: {
  //   "showData.suspensionComponent1.buttonImg": function(n) {
  //     const suspensionComponent1 = document.getElementById("children");
  //     if (n && suspensionComponent1) {
  //       // console.log("1122333");
  //       // console.log("n", n);
  //       // console.log("buttonImg");
  //       console.log("112233", n);
  //       suspensionComponent1.style.visibility = "visible";
  //       suspensionComponent1.style.backgroundImage = `url(${n})`;
  //     } else {
  //       suspensionComponent1.style.visibility = "hidden";
  //     }
  //   }
  // },
  mounted() {
    this.posX1 = window.innerWidth - 100;
    this.posY1 = window.innerHeight - 100 - 20;
    this.posX2 = 0;
    this.posY2 = window.innerHeight - 100 - 20;
    document.body.style.backgroundColor = "#ffd8b2";
    const { is_hll_user_app, is_hll_driver_app } = ua.parse();
    const cityId = getUrlParam("city_id");
    // 解决某个渠道不能带某个参数
    if (this.currentRef === "YH-HD") {
      this.portType = "hlluser";
    }
    // 司机个人中心-icon -> 司机端
    if (this.currentRef === "SJZX-icon") {
      this.portType = "hlldriver";
    }
    if (cityId) {
      this.urlCityId = cityId;
      this.getH5activityConfig({ cityId });
    }
    // if (this.portType !== "hlluser" && this.portType !== "hlldriver") {
    //   this.getPosition();
    // }
    if (!is_hll_user_app && !is_hll_driver_app) {
      this.getPosition();
    }
    if (defaultCode[this.currentRef]) {
      this.currentClueFrom =
        defaultCode[this.currentRef].clueFromCode || this.currentRef;
    }

    this.isHasSubmit();
    if (this.portType === "hlluser" || this.portType === "hlldriver") {
      this.addEventScroll();
    }
    this.initUserData().then(res => {
      if (!res) {
        return;
      }
      const data = [{ field: "uv", value: this.optionsData.phone }];
      this.recordViewInfo(data);
    });
    // 神策埋点 -曝光+来源-
    try {
      sensors.track("rent_activity", {
        platform_type: "H5",
        page_name: this.currentClueFrom || this.currentRef,
        $is_login_id: true,
        sources: this.currentClueFrom || this.currentRef,
        page_view: this.currentClueFrom || this.currentRef
      });
    } catch (err) {
      console.log(err);
    }

    setTimeout(() => {
      if (!this.showData.id) {
        this.getH5activityConfig();
      }
    }, 2200);
    if (!is_hll_user_app && !is_hll_driver_app) {
      this.gdLocation();
    }
    // app 定位
    // if (this.portType === "hlluser" || this.portType === "hlldriver") {
    //   this.isAppEnv = true;
    //   // 1. 先注入获取定位的 action
    //   window.getMyAppLocation = lat_lng => {
    //     console.log("LLLLLLLLLLLL", lat_lng);
    //     if (lat_lng) {
    //       const [lat, lng] = lat_lng.split("|");
    //       this.appLocation.lat = lat;
    //       this.appLocation.lng = lng;
    //       window.localStorage.setItem("lastAuthLocationStatus", "success"); // 获取成功时保存状态
    //     } else {
    //       const userId = this.optionsData.driverId;
    //       window.localStorage.setItem("lastAuthLocationStatus", "fail"); // 获取失败时也保存状态
    //       window.localStorage.setItem("lastUserId", userId);
    //       window.localStorage.setItem(
    //         "lastApplyAuthTime",
    //         new Date().valueOf()
    //       );
    //     }
    //   };
    //   const lastApplyAuthTime = window.localStorage.getItem(
    //     "lastApplyAuthTime"
    //   );
    //   const lastAuthLocationStatus = window.localStorage.getItem(
    //     "lastAuthLocationStatus"
    //   );
    //   const lastUserId = window.localStorage.getItem("lastUserId");
    //   if (!lastApplyAuthTime && !lastAuthLocationStatus) {
    //     getAppLocation({
    //       action: "position",
    //       callback: "getMyAppLocation"
    //     });
    //   }
    //   if (lastAuthLocationStatus === "success") {
    //     getAppLocation({
    //       action: "position",
    //       callback: "getMyAppLocation"
    //     });
    //   } else if (
    //     lastApplyAuthTime &&
    //     new Date().valueOf() - +lastApplyAuthTime > 1000 * 60 * 60 * 48 &&
    //     this.optionsData.driverId === lastUserId
    //   ) {
    //     getAppLocation({
    //       action: "position",
    //       callback: "getMyAppLocation"
    //     });
    //   }
    // }
    // const isAndroid = Boolean(navigator.userAgent.match(/android/gi));
    // const isIos = Boolean(navigator.userAgent.match(/iphone/gi));
    if (is_hll_user_app || is_hll_driver_app) {
      /**
       * @getCoordinates
       */
      this.isAppEnv = true;
      window.getCoordinates = coordinates => {
        console.log("coordinates", coordinates);
        if (coordinates) {
          const [lat, lng] = coordinates.split("|");
          this.appLocation.lat = lat;
          this.appLocation.lng = lng;
        }
      };
      getAppLocation({
        action: "getCoordinates",
        callback: "getCoordinates"
      });
      // this.isAppEnv = true;
      // window.getMyAppLocation = lat_lng => {
      //   console.log("UUUUUUUUUUUUU", lat_lng);
      //   if (lat_lng) {
      //     const [lat, lng] = lat_lng.split("|");
      //     this.appLocation.lat = lat;
      //     this.appLocation.lng = lng;
      //   }
      // };
      // getAppLocation({
      //   action: "position",
      //   callback: "getMyAppLocation"
      // });
    }
    // 拖拽事件绑定
    // var parentNode = document.getElementById("parent");
    // var childrenNode = document.getElementById("children");

    // this.dragFun(parentNode, childrenNode);
  },

  computed: {
    // 是否显示租车按钮(临时需求，针对 北京定制页，厦门定制页)
    // isShowRent() {
    //   if (!this.templateName) {
    //     return false;
    //   }
    //   if (
    //     this.templateName === "北京定制页" ||
    //     this.templateName === "厦门定制页"
    //   ) {
    //     return false;
    //   }
    //   return true;
    // }
    // isShowCode() {
    //   if (this.currentRef === "ZMT-AliPay") {
    //     return false;
    //   }
    //   if (this.currentRef === "XCX-ZFB") {
    //     return false;
    //   }
    //   return true;
    // }
  },
  methods: {
    shareWxMini() {
      const {
        appletsText,
        appletsImg,
        shareUrl
      } = this.showData.shareComponent;
      console.log("111222", appletsText, appletsImg, shareUrl);
      toShareMiprogramNew({ appletsText, appletsImg, shareUrl });
    },
    touchend(e) {
      if (this.dragCount2 === 0) {
        console.log("点击事件");
        this.xuan2Show = !this.xuan2Show;
        this.xuanfuIcon = this.xuan2Show
          ? "https://static.huolala.cn/image/8f9205ca1b058f825d04f32f81cecea1ee44f495.png"
          : "https://static.huolala.cn/image/8799b69cd23f702252f3502b7afbe1a35f192874.png";
      } else {
        console.log("拖动");
      }
    },
    touchendItem(e) {
      if (e) {
        const { img, redirectType, url } = e;
        this.jumpToWhere(redirectType, url, img);
      }
    },
    handleClicked1() {
      this.dragCount1 = 0;
    },
    handleDragStop1() {
      if (this.dragCount1 === 1) {
        const {
          redirectUrl: url,
          redirectType: type,
          buttonImg: img
        } = this.showData.suspensionComponent1;
        this.jumpToWhere(type, url, img);
      }
    },
    handleDragging1() {
      this.dragCount1 = this.dragCount1 + 1;
    },
    handleClicked2(e) {
      this.dragCount2 = 0;
    },
    // handleDragStop2() {
    //   if (this.dragCount2 === 1) {
    //     console.log("跳转小程序或者H5");
    //   }
    // },
    handleDragging2() {
      this.dragCount2 = this.dragCount2 + 1;
    },
    // dragFun(parentNode, childrenNode) {
    //   var disX = 0;
    //   var disY = 0;
    //   var isClick = false;
    //   childrenNode.ontouchstart = function(ev) {
    //     console.log("按下", ev.targetTouches[0]);
    //     console.log("按下", childrenNode.offsetLeft);
    //     //鼠标事件对象
    //     var oEvent = ev.targetTouches[0];
    //     disX = oEvent.clientX - childrenNode.offsetLeft;
    //     disY = oEvent.clientY - childrenNode.offsetTop;
    //     isClick = true;
    //     console.log("disX", disX, disY);

    //     document.ontouchmove = function(ev) {
    //       console.log("移动中", ev.targetTouches[0]);
    //       console.log("移动中", childrenNode.offsetLeft);
    //       console.log("parentNode", parentNode.clientHeight);
    //       console.log("childrenNode", childrenNode.offsetHeight);
    //       isClick = false;
    //       //鼠标事件对象
    //       var oEvent = ev.targetTouches[0];
    //       var l = oEvent.clientX - disX;
    //       var t = oEvent.clientY - disY;

    //       console.log("client", oEvent.clientX, oEvent.clientY);

    //       // if (l < 50) {
    //       //   l = 0;
    //       // } else if (l > parentNode.clientWidth - childrenNode.offsetWidth) {
    //       //   l = parentNode.clientWidth - childrenNode.offsetWidth;
    //       // }
    //       if (t < 50) {
    //         t = 0;
    //       } else if (t > parentNode.clientHeight - childrenNode.offsetHeight) {
    //         t = parentNode.clientHeight - childrenNode.offsetHeight;
    //       }

    //       // childrenNode.style.left = l + "px";
    //       childrenNode.style.top = t + "px";

    //       /**如果父盒子设置有marginTop和marginLeft则需要将其设置为0*/
    //       childrenNode.style.marginLeft = 0;
    //       childrenNode.style.marginTop = 0;
    //     };
    //     document.ontouchend = function() {
    //       isClick = false;
    //       document.ontouchmove = null;
    //       document.ontouchend = null;
    //     };
    //     //阻止默认事件
    //     return false;
    //   };
    //   childrenNode.ontouchend = function() {
    //     if (isClick) {
    //       console.log("点击事件");
    //     }
    //   };
    // },
    buidLocationAddress() {
      let r = "";
      if (this.gdCityData.city) {
        r = `${this.gdCityData.city} ${this.gdCityData.district}`;
      } else if (this.optionsData.city) {
        r = `${this.optionsData.city} ${this.optionsData.remarkCity}`;
      } else if (this.appLocation.city) {
        r = `${this.appLocation.city} ${this.appLocation.remarkCity}`;
      }
      this.optionsData.address = r;
      return r;
    },

    async gdLocation() {
      // let data = await gdLocation();
      // if (data.lat) this.gdCityData = data;
      let data = await getLocation();
      this.gdCityData = {
        ...this.gdCityData,
        city: data.city,
        district: data.district,
        lat: data.lat,
        lng: data.lng
      };
      this.buidLocationAddress();
    },
    comfirmClose() {
      this.popupVisible = false;
      this.removeEvent();
      // window.close()
      AppCloseWebView();
    },
    removeEvent() {
      window.removeEventListener("popstate", this.handleFun);
    },
    initListener() {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.openClosePopup);
    },
    openClosePopup() {
      // alert("你确定要关闭浏览器？");
      history.pushState(null, null, document.URL);
      this.popupVisible = true;
    },
    toSJZG() {
      try {
        recordClick("司机招募", this.templateName);
      } catch (err) {}
      window.location.href = "https://www.wjx.top/jq/78149456.aspx";
    },
    toShare() {
      try {
        recordClick("老带新", this.templateName);
      } catch (err) {}
      let token = getUrlParam("token");
      let _token = getUrlParam("_token");
      let url = "https://charter.huolala.cn/h5/hll-share-h5";
      const tmpHost = location.hostname;
      if (/-dev/.test(tmpHost)) {
        url = "https://charter-dev.huolala.cn/h5/hll-share-h5";
      }
      let ref = this.currentRef || "YH-sale";
      window.location.href = `${url}?ref=${ref}&clueFrom=${this.currentClueFrom}&portType=${this.portType}&token=${token}&_token=${_token}`;
    },
    localStorageClear() {
      localStorage.clear();
    },
    getPosition() {
      const appCityName = getUrlParam("getLinkAddCityName");
      if (appCityName) {
        this.appLocation.city = appCityName;
      }
      this.getLoc();
    },
    handleConfirmCityPick(value) {
      this.optionsData.address = [...new Set(value.map(e => e.name))].join(" ");
      this.cityPickerPopupVisible = false;
    },
    // 小图标左右移动动画
    addEventScroll() {
      this.isShow = true; // false: 已经隐藏  true: 已经显示
      let scrollTimer;
      window.addEventListener("scroll", e => {
        clearTimeout(scrollTimer);
        this.isShow = false;
        scrollTimer = setTimeout(() => {
          if (!this.isShow) {
            this.isShow = true;
          }
        }, 400);
      });
    },
    isHasSubmit() {
      this.submitTimeValue = calcSubmit();
    },
    initUserData() {
      let token = getUrlParam("token");
      let _token = getUrlParam("_token");
      // 用户端
      if (_token) {
        return getAppUserData(_token)
          .then(res => {
            if (res.phone) {
              this.optionsData.phone = res.phone || "";
              this.optionsData.nickName = res.nickName || "";
              if (res.driverId) this.optionsData.driverId = res.driverId || "";
            }
            return Promise.resolve("getAppUserData");
          })
          .catch(() => {
            return Promise.reject("getAppUserData");
          });
      }
      // 司机端
      else if (token) {
        return appDriverData(token)
          .then(res => {
            if (res.phone) {
              this.optionsData.phone = res.phone || "";
              this.optionsData.nickName = res.nickName || "";
              if (res.driverId) this.optionsData.driverId = res.driverId || "";
              setTimeout(() => {
                this.saveDriverData(res);
              }, 500);
            }
            return Promise.resolve("appDriverData");
          })
          .catch(() => {
            return Promise.reject("appDriverData");
          });
      } else {
        return Promise.resolve();
      }
    },
    recordViewInfo(data = []) {
      const baseData = [
        {
          field: "network",
          value: getNetworkType()
        },
        {
          field: "channel",
          value: this.currentRef
        },
        {
          field: "mode",
          value: this.mode
        },
        {
          field: "location_city",
          value: this.optionsData.city
        }
      ];
      const finalData = [...baseData, ...data];
      pageRecord(finalData);
    },
    saveDriverData(res) {
      try {
        webcall({
          action: "getAppInfo",
          callback: "getAppInfo"
        });
        window.getAppInfo = data => {
          let driverData = JSON.parse(data);
          let options = {
            ...res,
            os: driverData.os,
            version: driverData.version,
            revision: driverData.revision,
            userMd5: driverData.user_md5,
            device: driverData.device_id
          };
          recordDriver(options);
        };
      } catch (err) {}
    },
    getLoc() {
      getLocation().then(
        res => {
          if (!this.urlCityId && res.address.city) {
            this.getH5activityConfig({ cityName: res.address.city });
          }
          this.optionsData.city = res.address.city;
          this.optionsData.remarkCity = res.address.district;
          this.optionsData.lat = res.point.lat;
          this.optionsData.lng = res.point.lng;
          this.buidLocationAddress();
        },
        err => {
          console.log(err);
          if (!this.urlCityId) {
            this.getH5activityConfig();
          }
        }
      );
    },
    getH5activityConfig(payload = {}) {
      let url = `${lalaMallApi}h5activityConfig/getPageConfig`;
      if (this.templateId) {
        console.log("11");
        url = `${lalaMallNotAdminApi}h5activityConfig/getByTemplateId`;
      }
      let options = {
        cityId: payload.cityId,
        cityName: payload.cityName,
        templateId: this.templateId,
        clueFromCode: this.currentRef
      };
      let testNoCity = getUrlParam("testNoCity");
      if (testNoCity === "Y") {
        options.cityId = "";
        options.cityName = "";
      }
      if (this.showData.id) return;
      axios
        .get(url, {
          params: options
        })
        .then(response => {
          let { code, data } = response.data;
          if (this.showData.id) return;
          if (code === 0) {
            if (data) {
              this.initModuleList(data);
            } else {
              this.getH5activityConfig2();
              try {
                MtaH5.clickStat("accident", { name: "模板数据为空" });
              } catch (err) {
                console.log("err", err);
              }
            }
          } else {
            this.$toast({
              message: response.data.msg
            });
          }
        })
        .catch(error => {
          this.getH5activityConfig2();
          try {
            MtaH5.clickStat("accident", { name: "接口出错" });
            MtaH5.clickStat("accident", { name: error });
            MtaH5.clickStat("accident", { name: url });
            MtaH5.clickStat("accident", { name: JSON.stringify(options) });
          } catch (err) {
            console.log("err", err);
          }
          console.log(error);
        });
    },
    getH5activityConfig2() {
      let url = `${lalaMallApi}h5activityConfig/getPageConfig`;
      if (this.showData.id) return;
      axios
        .get(url, {})
        .then(response => {
          let { code, data } = response.data;
          if (this.showData.id) return;
          if (code === 0) {
            if (data) {
              this.initModuleList(data);
            } else {
              try {
                MtaH5.clickStat("accident", { name: "模板数据为空2" });
              } catch (err) {
                console.log("err", err);
              }
            }
          } else {
            this.$toast({
              message: response.data.msg
            });
            const info = [
              {
                field: "error",
                value: Date.now() - performance.timing.navigationStart
              }
            ];
            this.recordViewInfo(info);
          }
        })
        .catch(error => {
          try {
            MtaH5.clickStat("accident", { name: "接口出错2" });
            MtaH5.clickStat("accident", { name: error });
            MtaH5.clickStat("accident", { name: url });
          } catch (err) {
            console.log("err", err);
          }
          console.log(error);
          const info = [
            {
              field: "error",
              value: Date.now() - performance.timing.navigationStart
            }
          ];
          this.recordViewInfo(info);
        });
    },
    initModuleList(data) {
      console.log("data =======>", data);
      this.showData.id = data.id;
      this.templateName = data.templateName;
      // 单独处理车型视频
      this.filterVehicleIntroduce(data);
      // 单独处理视频
      this.filterVideoRecommend(data);
      for (let i of data.moduleList) {
        switch (i.moduleCode) {
          case "head":
            this.showData.header = i.moduleItemList[0].img; // 图片链接
            this.showData.bodyMarginTop = i.moduleItemList[0].carIntroduce; // 链接距离
            let btnText = i.moduleItemList[0].btnText; // 背景颜色
            if (btnText) {
              document.body.style.backgroundColor = btnText;
            }
            init_wx(i.moduleItemList[0].img); // 微信初始化一下
            break;
          case "advertising1": // 广告图1
            this.showData.advertising1 = i.moduleItemList[0].img;
            break;
          case "input": // 输入框
            this.showData.input = this.filterInputData(i);
            break;
          case "inputFooter": // 输入框
            console.log("112233", i);
            this.showData.inputFooter = this.filterInputData(i);
            break;
          // case "recommendCar": // 推荐车型
          //   this.showData.recommendCar = this.filterRecommendCar(i);
          //   break;
          // case "recommendCar2": // 推荐车型
          //   this.showData.recommendCar2 = this.filterRecommendCar(i);
          //   break;
          // case "buyCar": // 买车模块
          //   this.showData.buyCar = this.filterCarData(i);
          //   break;
          // case "twoCarModel": // 2辆车模块
          //   this.showData.twoCarModel = this.filterCarData(i);
          //   break;
          case "rentCar": // 买车模块
            this.showData.rentCar = this.filterCarData(i);
            break;
          // case "usedCar": // 二手车
          //   this.showData.usedCar = this.filterCarData(i);
          //   break;
          case "advertising2": // 广告图2
            this.showData.advertising2 = i.moduleItemList;
            break;
          case "advertising3": // 广告图3
            this.showData.advertising3 = i.moduleItemList;
            break;
          case "advertising4": // 广告图4
            this.showData.advertising4 = i.moduleItemList;
            break;
          case "successSubmit":
            // if (i.moduleItemList[0]) {
            //   this.showData.successSubmit.img = i.moduleItemList[0].img; // 提示小图
            //   this.showData.successSubmit.carIntroduce =
            //     i.moduleItemList[0].carIntroduce; // 提示小图
            //   this.showData.successSubmit.btnText = i.moduleItemList[0].btnText; // 提示小图
            //   this.showData.successSubmit.btnBackImg =
            //     i.moduleItemList[0].btnBackImg; // 提示小图
            // }
            if (i.moduleElement.successSubmit) {
              this.showData.successSubmit = i.moduleElement.successSubmit;
            }
            break;
          case "suspensionComponent1":
            if (i.moduleElement.suspensionComponent1) {
              this.showData.suspensionComponent1 =
                i.moduleElement.suspensionComponent1; // 悬浮框1
              this.suspensionComponent1Image =
                i.moduleElement.suspensionComponent1.buttomImg;
            }
            break;
          case "suspensionComponent2":
            if (i.moduleElement.suspensionComponent2) {
              this.showData.suspensionComponent2 =
                i.moduleElement.suspensionComponent2; // 悬浮框1
            }
            break;
          case "bottomQrCode":
            if (i.moduleElement.bottomQrCode) {
              this.showData.bottomQrCode = i.moduleElement.bottomQrCode;
            }
            break;
          case "shareComponent":
            if (i.moduleElement.shareComponent) {
              this.showData.shareComponent = i.moduleElement.shareComponent;
            }
            break;
          case "rollComponent":
            if (i.moduleElement.rollComponent) {
              this.showData.rollComponent = i.moduleElement.rollComponent;
            }
            break;
          //  successSubmit: {
          //   "img": '', // 提示小图
          //   "carIntroduce": '', // 提示文案1
          //   "btnText": '', // 按钮文案
          //   "btnBackImg": '', // 打开的url
          //   "orderNum": 1
          // }
        }
      }
      const info = [
        {
          field: "load_time",
          value: Date.now() - performance.timing.navigationStart
        }
      ];
      this.recordViewInfo(info);
    },
    filterRecommendCar(i) {
      let recommendCar = {};
      if (i.introduce) recommendCar.introduce = i.introduce;
      for (let j of i.moduleItemList) {
        switch (j.orderNum) {
          case 1:
            recommendCar.img = j.img;
            break;
          case 2:
            recommendCar.carImg = j.carImg;
            recommendCar.carIntroduce = j.carIntroduce;
            recommendCar.carName = j.carName;
            break;
          case 3:
            recommendCar.btnText = j.btnText;
            recommendCar.btnBackImg = j.btnBackImg;
            break;
        }
      }
      return recommendCar;
    },
    filterInputData(i) {
      let inputData = {};
      if (i.moduleCode === "input") {
        inputData = { ...i.moduleElement.input };
      }
      // if (i.moduleCode === "inputFooter") {
      // inputData.img = i.moduleItemList[0].img;
      // inputData.btnBackImg = i.moduleItemList[1].btnBackImg;
      // inputData.btnText = i.moduleItemList[1].btnText;
      // inputData.carName = i.moduleItemList[1].carName;
      // inputData.openUrl = i.openUrl;
      // inputData.introduce = i.introduce;
      // inputData = { ...i.moduleElement.inputFooter };
      // }
      return inputData;
    },
    filterCarData(i) {
      let datas = {};
      if (i.introduce) datas.introduce = i.introduce;
      let carList = [];
      for (let j of i.moduleItemList) {
        switch (
          j.orderNum // 基础配置
        ) {
          case 1:
            datas.headerImg = j.img;
            break;
          case 2:
            datas.contentImg = j.img;
            break;
          case 3:
            datas.advantageImg = j.img;
            break;
          case 4:
            datas.btnBackImg = j.btnBackImg;
            datas.btnText = j.btnText;
            break;
        }
        if (j.carImg) carList.push(j);
      }
      datas.carList = carList;
      return datas;
    },
    filterVehicleIntroduce(data) {
      const vehicleIntroduce = data.moduleList
        .filter(i => i.moduleCode === "vehicleIntroduce")
        .map(i => i.moduleElement)
        .map(i => i.vehicleIntroduce);
      this.vehicleIntroduceOptions = vehicleIntroduce;
    },
    filterVideoRecommend(data) {
      const videoRecommend = data.moduleList
        .filter(i => i.moduleCode === "videoRecommend")
        .map(i => i.moduleElement)
        .map(i => i.videoRecommend)
        .filter(item => item !== null);
      this.videoRecommendOptions = videoRecommend;
    },
    changeType(typeName, name) {
      this.optionsData.carType = typeName;
    },
    openCity() {
      console.log("打开openCity");
    },
    changeVehicle(payload) {
      if (this.submitTimeValue) {
        this.$toast({
          message: "已预约过，无需重复预约"
        });
        return;
      }

      let datas = payload.datas;
      if (payload.typeName === "buy") {
        datas.downPayment = "超低首付";
      }
      this.intentionVehicle = datas;
      this.$refs.popupBottomBox.open(payload);
      recordClick(payload.datas.carName, this.templateName);
    },
    save(payload) {
      let comName = "";
      let lat = this.appLocation.lat || "";
      let lng = this.appLocation.lng || "";
      let remark = "";
      // 默认用腾讯地图的定位
      if (this.optionsData.city) {
        let city = this.optionsData.city || "";
        let timer = 0;
        try {
          timer = new Date().getFullYear();
        } catch (err) {}
        // 2021年开启高德
        if (
          (city.includes("杭州") ||
            city.includes("Hangzhou") ||
            (this.optionsData.lat == "30.26555" &&
              this.optionsData.lng == "120.1536")) &&
          timer > 2020 &&
          this.gdCityData.city
        ) {
          // 高德地图
          // gdCityData: {
          //   city: "",
          //   lat: "",
          //   lng: "",
          //   district: ""
          // },
          comName = this.gdCityData.city;
          lat = this.gdCityData.lat;
          lng = this.gdCityData.lng;
          remark = `定位城市:${this.gdCityData.city}${this.gdCityData.district}(高德)`;
        } else {
          comName = this.optionsData.city;
          lat = this.optionsData.lat;
          lng = this.optionsData.lng;
          remark = `定位城市:${this.optionsData.city}${this.optionsData.remarkCity}(腾讯)`;
        }
      }

      // 没有就用app
      if (!comName && this.appLocation.city) {
        comName = this.appLocation.city;
        lat = this.appLocation.lat;
        lng = this.appLocation.lng;
        remark = `定位城市:${this.appLocation.city}${this.appLocation.remarkCity}(app)`;
      }
      const businessTypeMap = {
        rent: 1,
        buy: 2,
        used: 3,
        replaceBuy: 4,
        sale: 5
      };
      let options = {
        name: this.optionsData.name,
        code: this.optionsData.captcha,
        channelCode: this.currentRef || "YH-sale",
        address: this.optionsData.address,
        city: comName,
        lat,
        lng,
        businessType: businessTypeMap[this.optionsData.carType],
        mobile: this.optionsData.phone // 号码
      };
      if (
        this.want === "0" ||
        this.showData.input.customerIntention.length === 0
      ) {
        delete options.businessType;
      }
      var reg = /^[1][0-9]{10}$/;
      if (!reg.test(options.mobile) || options.mobile.length != 11) {
        this.$toast({
          message: "信息提交失败，请确认您的手机号码是否正确"
        });
        return;
      }
      // 有mode参数就校验地址
      if (this.mode) {
        if (!options.address) {
          this.$toast({
            message: "请选择您的所在位置"
          });
          return;
        }
        // 模式1校验姓名和验证码
        if (this.mode === "1") {
          if (!options.name) {
            this.$toast({
              message: "请输入姓名"
            });
            return;
          }
          if (!options.code) {
            this.$toast({
              message: "请输入验证码"
            });
            return;
          }
        }
        // 模式2校验验证码
        if (this.mode === "2") {
          if (!options.code) {
            this.$toast({
              message: "请输入验证码"
            });
            return;
          }
        }
      }
      let ref2 = getUrlParam("ref2");
      if (ref2) {
        options.remark += `,ref2:${ref2}`;
      }
      const loading = this.$toast.loading({
        message: "请求中...",
        forbidClick: true,
        duration: 0
      });
      if (this.templateId == 253) {
        options.channelCode = this.optionsData.carType == 'yc' ? 'XB-mdlz-yc' : 'XB-mdlz-wc'
      }
      api
        .addClue(options)
        .then(response => {
          loading.clear();
          if (response.data.code === 0) {
            if (response.data.data === 0) {
              if (this.optionsData.carType === "rent") {
                this.$toast.success("预约租车成功");
              } else {
                this.$toast.success("预约成功");
              }
              calcSubmit(this.optionsData.carType);
              this.submitTimeValue = this.optionsData.carType;
              this.$refs.popupBottomBox.close();
              localStorage.phone = this.optionsData.phone;
              // 埋点多平台上报
              const assets_id = pointMap[this.currentRef];
              if (assets_id) {
                _baq.track("form", {
                  assets_id
                });
              }
              // 快手买点平台上报
              _ks_trace.push({
                event: "form",
                convertId: 528986,
                cb: function() {
                  console.log("Your callback function here!");
                }
              });
              // 巨量引擎上报 start
              // _baq.track("form", {
              //   assets_id: "1748373590312003"
              // });
              // _baq.track("form", {
              //   assets_id: "1748351872300035"
              // });
              // _baq.track("form", {
              //   assets_id: "1749543359726595"
              // });
              // 巨量引擎上报 start
            }
            if (response.data.data === 1) {
              if (this.optionsData.carType === "rent") {
                this.$toast.success("预约租车成功");
              } else {
                this.$toast.success("预约购车成功");
              }
              calcSubmit(this.optionsData.carType);
              this.submitTimeValue = this.optionsData.carType;
              this.$refs.popupBottomBox.close();
              localStorage.phone = this.optionsData.phone;
            }
            if (response.data.data === 2) {
              this.$toast({
                message: "您今日已留资，请勿重复提交"
              });
            }
          } else {
            this.$toast.fail(response.data.msg);
          }
          const info = [
            {
              field: "stay_time",
              value: Date.now() - performance.timing.navigationStart
            },
            {
              field: "http_status",
              value: response.status
            },
            {
              field: "mobile",
              value: options.mobile
            }
          ];
          this.recordViewInfo(info);
        })
        .catch(err => {
          console.log("err", err);
          loading.clear();
          const info = [
            {
              field: "stay_time",
              value: Date.now() - performance.timing.navigationStart
            },
            {
              field: "mobile",
              value: options.mobile
            }
          ];
          this.recordViewInfo(info);
        });
      if (payload) recordClick(payload, this.templateName);
    },
    // 跳转第三方按钮
    // typeName: 'miniprogram',
    // recordName: '浮动图标打开小程序',
    // openPopupType: 'signIn' signIn 抽奖页 home: 首页
    // page: page/tabBar/homepage/index
    goOtherActivity(type, url, imgUrl) {
      if (type && url) {
        this.jumpToWhere(type, url, imgUrl);
      }
      // switch (payload.typeName) {
      //   case "url":
      //     recordClick(payload.recordName, this.templateName);
      //     let ADTAG = getUrlParam("ADTAG");
      //     let token = getUrlParam("token");
      //     let _token = getUrlParam("_token");
      //     let portType = getUrlParam("portType");
      //     let ref = this.currentRef;
      //     let phone = localStorage.phone || "";
      //     let userId = localStorage.userId || "";
      //     // let url = `${payload.url}?phone=${phone}&token=${token}&ref=${ref}&_token=${_token}&portType=${portType}&ADTAG=${ADTAG}`;
      //     let url = "";
      //     if (payload.url.indexOf("ref") > -1) {
      //       url = `${payload.url}&phone=${phone}&token=${token}&_token=${_token}&portType=${portType}&ADTAG=${ADTAG}`;
      //     } else {
      //       url = `${payload.url}&phone=${phone}&token=${token}&ref=${ref}&_token=${_token}&portType=${portType}&ADTAG=${ADTAG}`;
      //     }
      //     window.localStorage.setItem("phone", phone);
      //     window.location.href = url;
      //     break;
      //   case "miniprogram":
      //     try {
      //       if (this.portType === "hlluser") {
      //         openWXMiniprogram(
      //           payload.page || payload.url,
      //           showData.shareComponent.appletsImg,
      //           showData.shareComponent.appletsText
      //         );
      //       } else {
      //         this.$refs.saveImgPopupBox.open(payload.openPopupType);
      //       }
      //     } catch (err) {
      //       this.$refs.saveImgPopupBox.open(payload.openPopupType);
      //     }
      //     break;
      // }
    },
    handleSuspensionComponent1Click() {
      const { redirectUrl } = this.showData.suspensionComponent1;
      const { is_hll_user_app, is_hll_driver_app } = ua.parse();
      if (is_hll_user_app || is_hll_driver_app) {
        console.log("小程序", redirectUrl);
      } else {
        console.log("跳转h5");
      }
    },
    handleLaunch() {
      console.log("launch success");
    },
    handleError(err) {
      console.log("error", err);
    },
    handleItemClick(item) {
      console.log("端内小程序  端外h5", item);
    },
    handleXuanfu2() {
      console.log("11112233");
      this.xuan2Show = !this.xuan2Show;
      this.xuanfuIcon = this.xuan2Show
        ? "https://static.huolala.cn/image/8f9205ca1b058f825d04f32f81cecea1ee44f495.png"
        : "https://static.huolala.cn/image/8799b69cd23f702252f3502b7afbe1a35f192874.png";
    },
    jumpToWhere(type, url, img) {
      if (
        ["hlluser", "hlldriver"].includes(this.portType) &&
        type === 2 &&
        url
      ) {
        Dialog.confirm({
          title: "跳转提醒",
          message:
            "即将跳转微信小程序，小程序将会在您注册/登录后收集相关个人信息，详细请参考小程序中的隐私协议",
          confirmButtonText: "继续",
          confirmButtonColor: "#F16927"
        })
          .then(() => {
            openWXMiniprogram(url, img, "");
          })
          .catch(() => {});
      }
      if (
        ["hlluser", "hlldriver", "self", "wechat"].includes(this.portType) &&
        type === 1 &&
        url
      ) {
        window.location.href = url;
      }
      if (type === 3) {
        // window.location.href = url;
        this.$refs["saveImgPopupBox"].open();
      }
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/css/rpx.scss";
@import "./common.scss";

.share {
  position: fixed;
  right: rpx(0);
  top: rpx(50);
  width: rpx(135);
  height: rpx(60);
  z-index: 999;
}

#parent {
  position: fixed;
  bottom: 20px;
  right: 0;
  width: 100px;
  height: 100%;
  pointer-events: none;
}

#children {
  position: absolute;
  width: 100px;
  height: 100px;
  bottom: 0;
  right: 0;
  background-size: 100% 100%;
  cursor: pointer;
  pointer-events: auto;
}
.vdr.active:before {
  display: none;
}
.drag-box {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  .drag-box-child-1 {
    position: absolute;
    pointer-events: auto;
    width: 100px;
    height: auto;
  }
  .drag-box-child-2 {
    position: absolute;
    pointer-events: auto;
    width: 100px;
    height: auto;
    .left-box {
      position: absolute;
      left: 0;
      top: 0;
      width: rpx(196);
      height: rpx(82);
      line-height: rpx(82);
      justify-content: space-around;
      overflow: hidden;
      background-color: #ff7310;
      font-size: rpx(28);
      color: white;
      z-index: 10;
      display: flex;
      border-radius: 0 rpx(41) rpx(41) 0;
      .item2 {
        width: rpx(7.93);
        img {
          width: 100%;
        }
      }
    }
    .right-box {
      position: absolute;
      left: 0;
      top: 0;

      height: rpx(82);
      line-height: rpx(82);
      overflow: hidden;
      background-color: white;
      font-size: rpx(28);
      color: black;
      z-index: 9;
      border-radius: 0 rpx(41) rpx(41) 0;
      .item-box {
        margin-left: rpx(196);
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        justify-items: center;
        .item-box-item {
          flex: 1;
          text-align: center;
          padding-right: rpx(5);
          img {
            width: rpx(60);
            height: auto;
            margin: rpx(11) rpx(20);
          }
        }
      }
    }
  }
}

.home-layout {
  header {
    position: relative;
  }
  .blank-model {
    height: rpx(40);
  }
  .inner-box {
    position: relative;
    z-index: 10;
  }
  .rollComponent {
    position: relative;
    @keyframes loop {
      0% {
        top: rpx(210);
      }

      100% {
        top: rpx(-210);
      }
    }
    @keyframes loop2 {
      0% {
        top: rpx(210);
      }

      100% {
        top: rpx(-210);
      }
    }
    .price-list {
      height: rpx(42);
      position: relative;
      font-size: rpx(24);
      top: 0rem;
      left: 0rem;
      color: #ef3b00;
      width: 5.8rem;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin: 0 auto;
      border-radius: rpx(21);
      .price-title {
        line-height: rpx(42);
      }
      .price-list-item {
        height: rpx(210);
        position: absolute;
        width: 100%;
        .price-list-item-l {
          height: rpx(42);
          line-height: rpx(42);
        }
      }
      .list-item-1 {
        background: #ffffff;
        animation: loop 10s linear infinite;
      }
      .list-item-2 {
        background: #ffffff;
        top: rpx(210);
        animation: loop2 10s 5s linear infinite;
      }
    }
  }
}
.localStorage-clear {
  position: fixed;
  bottom: 10px;
  right: 10px;
  padding: 6px 20px;
  background: #ccc;
  z-index: 1000;
}

.car-list-box {
  margin: 0 rpx(30);
  border-radius: rpx(20);
  font-size: 0;

  .car-head {
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 0 rpx(20);
    img {
      width: 100%;
    }
  }

  .car-list-body {
    overflow: hidden;
    background: #fff;
    padding: rpx(36) rpx(20) 0 rpx(20);
    border-radius: rpx(20);
    .car-head-tit {
      font-size: rpx(32);
      color: #6647de;
      margin: rpx(37) 0 0 rpx(25);
    }
    .driver-1 {
      width: 100%;
    }
    .car-img-detail {
      padding-top: rpx(30);
      img {
        width: 100%;
      }
      .footer-box {
        align-items: flex-end;
        overflow: hidden;
        margin: rpx(33) 0 rpx(32) 0;
        .left-tit {
          display: flex;
          vertical-align: top;
          justify-content: center;
          margin-bottom: rpx(20);
          p:first-child {
            font-size: rpx(30);

            color: #666666;
            margin-right: rpx(30);
          }
          p:last-child {
            font-size: rpx(36);

            color: #4a4e5d;
          }
        }
      }
      .order-cion {
        width: 100%;
        height: rpx(96);
        background: linear-gradient(
          90deg,
          rgba(255, 174, 34, 1) 0%,
          rgba(255, 96, 8, 1) 100%
        );
        box-shadow: 0 rpx(10) 0 0 rgba(224, 90, 20, 1);
        border-radius: rpx(48);
        color: #fff;
      }
    }
    .car-tip {
      width: fit-content;
      color: #999999;
      font-size: rpx(22);
      line-height: rpx(34);
      width: 80%;
      margin: 0 auto;
      text-align: center;
      margin-bottom: rpx(15);
    }
    .footer-tit {
      padding: 0 rpx(46);
      font-size: rpx(24);
      line-height: rpx(40);
      margin-bottom: rpx(20);
      color: #999999;
      text-align: center;
    }
    .more-car {
      width: rpx(464);
      height: rpx(92);
      background: url("~@/assets/img/more-car.png") no-repeat;
      background-size: 100% 100%;
      margin: rpx(20) auto;
    }
  }
  .advantage-img {
    font-size: 0;
    margin: 0 0 rpx(20) 0;
    text-align: center;
    img {
      height: auto;
      max-width: 100%;
      // height: rpx(42);
    }
  }
  .car-header {
    padding: 0 0 rpx(24) 0;
    li {
      text-align: center;
    }
    .header-tit {
      font-size: rpx(32);
      color: #4a4e5d;
      span {
        color: #fe2b01;
      }
    }
    .time-tit {
      font-size: rpx(28);
      margin-top: rpx(6);
      color: #888d97;
    }
  }
  .advantage-list {
    font-size: 0;
    margin: rpx(32) 0 rpx(20) 0;
    li {
      display: inline-block;
      border: 1px solid #00aeff;
      border-radius: rpx(8);
      font-size: rpx(24);
      padding: rpx(6) rpx(8);
      color: #00aeff;
      margin-right: rpx(10);
      margin-bottom: rpx(20);
    }
    .on {
      background: #00aeff;
      color: #fff;
    }
  }
  .advantage-list-2 {
    li {
      border: 1px solid #f04545;
      color: #f04545;
      margin-bottom: rpx(20);
    }
    .on {
      background: #f04545;
    }
  }
  .img-group-list-box {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 50%;
      margin: rpx(30) 0 rpx(30) 0;
    }
    li:nth-child(odd) {
      padding-right: rpx(5);
    }
    li:nth-child(even) {
      padding-left: rpx(5);
    }
  }
  .car-buy-footer-box {
    font-size: rpx(24);
    color: #999999;
    text-align: center;
    margin-bottom: rpx(18);
  }
  .img-group-box {
    position: relative;
    .img-tit {
      position: absolute;
      top: 0;
      display: inline-block;
      font-size: rpx(24);
      color: #fff;
      background: #00aeff;
      padding: 0 rpx(10);
      border-radius: 0 rpx(20) 0 rpx(20);
      margin-bottom: rpx(5);
    }
    .img-tit-2 {
      background: #f04545;
    }
    img {
      width: 100%;
    }
    .small-btn-bg {
      font-size: rpx(28);
      color: #fff;
      border-radius: rpx(30);
      display: inline-block;
      width: rpx(225);
      height: rpx(70);
      line-height: rpx(70);
      text-align: center;
      // background: url("~@/assets/img/small-btn-bg.png") no-repeat;
      background-size: 100% 100%;
    }
    .tit-1 {
      font-size: rpx(28);
      color: #666666;
      margin-top: rpx(5);
      text-indent: rpx(20);
    }
    .tit-2 {
      font-size: rpx(32);
      color: #212121;
      margin-top: rpx(18);
      margin-bottom: rpx(23);
      text-indent: rpx(20);
    }
  }
  .img-group-list-rent-box {
    padding: rpx(24) 0 rpx(60) rpx(49);
    li {
      display: flex;
      margin-bottom: rpx(10);
      img {
        width: rpx(331);
        height: rpx(227);
        margin-right: rpx(30);
      }
      .right-box {
        padding-top: rpx(10);
        .tit-one {
          color: #4a4e5d;
          font-size: rpx(28);
        }
        .tit-two {
          color: #ff601a;
          font-size: rpx(32);
          margin: rpx(24) 0 0 0;
        }
        .rent-car-submit {
          height: rpx(52);
          width: rpx(168);
          background: linear-gradient(to right, #ff534b, #ff8744);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: rpx(30);
          color: #fff;
          margin-top: rpx(42);
          font-size: rpx(24);
        }
      }
    }
  }
}
#lottery-icon-box {
  position: fixed;
  bottom: 50px;
  width: 73px;
  height: 67px;
  right: 0;
  overflow: hidden;
  z-index: 10;
  img {
    width: 68px;
    height: 67px;
    position: absolute;
  }
}
#lottery-icon-box-2 {
  position: fixed;
  bottom: 100px;
  width: rpx(196);
  height: rpx(82);
  line-height: rpx(82);
  justify-content: space-around;
  left: 0;
  overflow: hidden;
  background-color: #ff7310;
  font-size: rpx(28);
  color: white;
  z-index: 10;
  display: flex;
  border-radius: 0 rpx(41) rpx(41) 0;
  .item2 {
    width: rpx(7.93);
    img {
      width: 100%;
    }
  }
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.close-hint-popup {
  width: rpx(480);
  // height: rpx(300);
  border-radius: rpx(10);
  overflow: hidden;
  h5 {
    font-size: rpx(30);
    margin: rpx(30) 0 rpx(70) rpx(30);
    color: #000;
    font-weight: normal;
  }
  .confirm {
    margin: 0 rpx(30);
    height: rpx(80);
    font-size: rpx(32);
    border-radius: rpx(5);
    background: #f16622;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .cancel {
    margin: rpx(20) rpx(30);
    height: rpx(80);
    font-size: rpx(32);
    border-radius: rpx(5);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f16622;
  }
}
.bottom-profile {
  color: white;
  text-align: center;
  p {
    margin: rpx(20);
  }
}
.single-img-box {
  margin: 0 rpx(30) 0 rpx(30);
}
</style>
